module.exports = __webpack_public_path__ + "static/img/schedule_an_appointment_for_a_patient.048bb30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/schedule_an_appointment_for_a_patient.jpg
// module id = 8r6h
// module chunks = 7